import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgArrowUpAlt = function SvgArrowUpAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("g", {
    clipPath: "url(#arrow-up-alt_svg__clip0)"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M3.21 11.033c0-.14.048-.375.235-.562l8.532-8.532 8.578 8.532a.897.897 0 01.234.562.82.82 0 01-1.406.563l-3.047-3-3.422-3.375v15.75a.99.99 0 01-.984.984.961.961 0 01-.985-.984V5.22L7.57 8.549l-3.047 3a.82.82 0 01-1.171 0c-.141-.14-.141-.375-.141-.516zm-2.015 0c0 .75.282 1.453.844 2.016a2.8 2.8 0 003.938 0l3.046-3v11.015a2.94 2.94 0 002.954 2.954 2.94 2.94 0 002.953-2.954V10.096l3.047 3c1.078 1.078 2.859 1.078 3.984 0 .562-.563.844-1.266.844-1.969 0-.703-.282-1.453-.844-1.969L13.383.58c-.797-.797-2.063-.797-2.813 0L2.04 9.064c-.563.516-.845 1.266-.845 1.97z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "arrow-up-alt_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z",
    transform: "rotate(-90 12 12)"
  }))));
};

export default SvgArrowUpAlt;